/* eslint-disable */
var JCP = {
  setup: {
    download: 'http://dddy.sen-chang.cn/tms-resources/setup.exe',
    download_linux: 'http://print.jatools.com/jcp/setup.run',
    noSetupMessage: '杰表云打印（JCP）未安装, 请下载安装之.'
  },
  licenseURL: '/printer/service/lic.jsp',
  jcpd: 'http://print.jatools.com:8098/service'
}
// var JSON = JSON || {}
var JSON = {}
// var _hmt = _hmt || []
var _hmt = []
var jsid2 = 'wc'
var $$ = function(e, d, f) {
  d = document,
  f = 'addEventListener'
  d[f] ? d[f]('DOMContentLoaded', e) : window['attachEvent']('onload', e)
}
$$(function() {
  if (document.location.href.indexOf('print.jatools.com') > -1) {
    var c = function() {
      var e = document['getElementsByTagName']('a')
      var f = new RegExp('(^|\s)help(\s|$)')
      for (var d = 0x0; d < e.length; d++) {
        if (f.test(e[d].className)) {
          return e[d]
        }
      }
      return null
    }
    var b = c()
    if (b) {
      var a = b.getAttribute('href')
      if (a.indexOf('/doc/') == 0) {
        b.href = '/doc/?' + a.substring(5)
      }
      setTimeout(function() {
        var d = document.createElement('script')
        d.onload = function() {
          showtip(b)
        }
        d.src = '/jcp/0.99/tooltip.js'
        ((isIE && ieVersion < 9) ? document.getElementsByTagName('head')[0] : document.head).appendChild(d);
      }, 5000)
    }
  }
  if ((document.referrer || '').indexOf('print.jatools.com') > -1) {
    (function() {
      var e = document.createElement('script')
      e.src = "https://hm.baidu.com/hm.js?d741f9d5528ec69713548d20a69531cf"
      var d = document.getElementsByTagName('script')[0]
      d.parentNode.insertBefore(e, d)
    }())
  }
})
var ua = window.navigator.userAgent // ua
var isIE = ua.match(/(?:MSIE |Trident\/.*; rv:)(\d+)/) // isIE
var ieVersion = isIE ? document.documentMode : -1 // ieVersion
var ie89 = isIE && (ieVersion == 8 || ieVersion == 9) // ie89
var ie10before = isIE && ieVersion < 10 // ie10before
var https = location.protocol === 'https:'
var SSL = isIE && https && !JCP.NOSSL // SSL
var PROTOCOL = SSL ? "https://" : "http://" // PROTOCOL
var PORT = SSL ? ":31443" : ":31227" // PORT
var LOCALhost = SSL ? "localhost" : '127.0.0.1' // LOCALhost
var LOCALhostapi = LOCALhost + PORT
var EXPORT_HOST = "www.jPORTools.com" // EXPORT_HOST
var newtabforpreview = ![] // newtabforpreview
var jr = '' // jr
var JSONparse = JSON.parse || function(str) {
  if (str === '') {
    str = '""'
  }
  eval('jr=' + str + ';')
  return jr
}
var xhrs = [{
  xhr: window.XMLHttpRequest || null,
  type: 1
}, {
  xhr: window.XDomainRequest || null,
  type: 2
}, {
  xhr: window.ActiveXObject || null,
  type: 3,
  args: 'MSXML2.XMLHTTP.3.0'
}, {
  xhr: '',
  type: -1
}]
var currentxhrs = [{
  index: -1
}, {
  index: -1,
  exclude: 2
}]
function getXHR(a) {
  var b = currentxhrs[a ? 0 : 1];
  if (!b.xhr) {
    nextXHR(a)
  }
  return b.xhr
}
function i18n(a) {
  return a
}
function nextXHR(a) {
  var b = currentxhrs[a ? 0 : 1]
  for (b.index++; true; b.index++) {
    var c = xhrs[b.index]
    if (c.type == -1) {
      b.xhr = null
      alert(i18n('ajax错误.'))
      break
    }
    if (c.xhr && c.type !== (c.exclude || -1)) {
      b.xhr = c
      break
    }
  }
}
var __jsonp__result__ = null;
function jsonp(b, c) {
  var a = document.createElement('script')
  a.onload = function() {
    c && c(__jsonp__result__, 200)
    c = null
  }
  a.onerror = function() {
    c && c(null, 404)
    c = null
  }
  setTimeout(function() {
    c && c(null, 404)
    c = null
  }, 5000)
  a.src = b
  document.getElementsByTagName('head')[0].appendChild(a)
}
function getOS() {
  var e = window.navigator.userAgent
    , a = window.navigator.platform
    , f = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
    , b = ['Win32', 'Win64', "Windows", 'WinCE']
    , c = ['iPhone', 'iPad', 'iPod']
    , d = null;
  if (f.indexOf(a) !== -1) {
    d = '_mac'
  } else {
    if (c.indexOf(a) !== -1) {
      d = '_ios'
    } else {
      if (b.indexOf(a) !== -0x1) {
          d = ''
      } else {
        if (/Android/.test(e)) {
          d = '_android'
        } else {
          if (!d && /Linux/.test(a)) {
            d = '_linux'
          }
        }
      }
    }
  }
  return d
}
function ajax_(c, f, i, b) {
  var d = c.indexOf(LOCALhostapi) > -1
  try {
    var a = null
    var h = getXHR(d)
    if (h.args) {
      a = new h.xhr(h.args)
    } else {
      a = new h.xhr()
    }
    if (SSL && 'withCredentials' in a) {
      a.withCredentials = true
    }
    a.open(f ? 'POST' : 'GET', c, 1)
    if (h.type == 2) {
      a.timeout = 3000
      a.onload = function() {
        b && b(a.responseText, 200)
      }
      a.ontimeout = function() {
        i && i(f, a.responseText, 404)
      }
      a.onerror = function() {
        i && i(f, a.responseText, 404)
    }
      a.onprogress = function() {}
      a.send(f)
    } else {
      a.onreadystatechange = function() {
        try {
          a.readyState > 3 && b && b(a.responseText, a.status)
        } catch (j) {
          j.internal = true
          throw j
        }
      }
      a['send'](f)
    }
  } catch (g) {
    if (!g.internal) {
      nextXHR(d)
      ajax_(c, f || null, i || null, b || null)
    }
  }
}
JCP.lic = null
function getlic(d, c) {
  if (JCP.lic == null && JCP.licenseURL) {
    if (window.location.hostname == '127.0.0.1') {
      JCP.lic = {}
      d()
      return
    }
    var b = PROTOCOL + (c || LOCALhost) + PORT + '/api?type=salt'
    var a = function(h, e) {
      if (e == 200) {
        var g = h.split(':')
        var f = JCP.licenseURL
        if (JCP.licenseURL.indexOf('!') == 0) {
          f = f.substring(1)
        } else {
          f = getAbsoluteUrl(f)
        }
        f = f + "?salt=" + g[0]
        ajax_(f, null, null, function(j, i) {
          if (i == 200) {
            try {
              j = JSONparse(j || "{}") || {}
              if (j.digest) {
                if (g[1]) {
                  j.salted = parseInt(g[1])
                }
                j.salt = g[0]
                JCP.lastlic = JCP.lic = j
              }
            } catch (err) {}
          }
          d()
        })
      } else {
        d(e)
      }
    }
    if (https && isIE) {
      b += '&jsonp=1'
      jsonp(b, a)
    } else {
      ajax_(b, null, a, a)
    }
  } else {
    d()
  }
}
function Jcp(ip, forward, password, test_token) {
  function log(e) {}
  function ajax(url, data, callback, result) {
    try {
      if (data && typeof (data) === 'object') {
        data.tab = tab_id || ''
        data = JSONstringify(data)
      }
      ajax_(url, data || null, callback || null, function(res, status) {
        var data = JSONparse(res || '{}')
        if (result) {
          data = typeof (data.result) == 'undefined' ? '' : data.result
        }
        callback && callback(data, res, status)
      })
    } catch (e) {
      log(e)
    }
  }
  function ___(doc, id) {
    return doc.getElementById(id)
  }
  function ___getCSS(d) {
    var b = ''
    var e = d.styleSheets
    for (var g = 0; g < e.length; g++) {
      var h = e[g]
      try {
        var c = h.cssRules
        if (c) {
          for (var a = 0; a < c.length; a++) {
            b += c[a].cssText || ''
          }
        } else {
          if (h.cssText) {
            b += h.cssText
          }
        }
      } catch (e) {}
    }
    return (b + '').replace(/[\s]*\n/gm, '')
  }
  function ___outerHTML(doc, node, ins) {
    if (doc.doctype) {
      node.setAttribute('_strict', 'true')
    }
    return node.outerHTML || (function(n) {
      var div = doc.createElement('div')
      div.appendChild(n.cloneNode(true))
      var h = div.innerHTML
      div = null
      return h
    })(node)
  }
  var thisdone
  function ___getDocumentItem(doc, myDoc) {
      var ins = myDoc.inputs || false
      if (typeof (doc.getElementById) != 'undefined') {
          if (ins) {
            var noframecheck = ins['no-frame-check'] || false
            var inps = doc.getElementsByTagName('input')
            for (var i = 0; i < inps.length; i++) {
              var inp = inps[i]
              if (inp.type == 'checkbox' || inp.type == 'radio') {
                if (inp.checked) {
                  inp.setAttribute('checked', inp.checked)
                } else {
                  inp.removeAttribute('checked')
                }
              } else {
                inp.setAttribute('value', inp.value)
              }
            }
            inps = doc.getElementsByTagName('textarea')
            for (var i = 0; i < inps.length; i++) {
              var inp = inps[i]
              inp.innerHTML = inp.value.replace('\n', '') // 原来是 inp.innerHTML = inp.value.replace("\n", "&#13;&#10;")
            }
            inps = doc.getElementsByTagName('select')
            for (var i = 0; i < inps.length; i++) {
              var inp = inps[i];
              inp.setAttribute('text', inp.options[inp.selectedIndex].text)
            }
          }
          var html = '';
          var result = {
            style: myDoc.importStyle || ___getCSS(doc)
          }
          if (myDoc.pages) {
            for (var i = 0; i < myDoc.pages.length; i++) {
              var page = myDoc.pages[i]
              if (typeof (page.substring) != 'undefined') {
                page = ___(doc, page)
              }
              html += ('<div id="page' + (i + 1) + '">' + ___outerHTML(doc, page, ins) + '</div>')
            }
          } else {
            if (myDoc.jobPages) {
              if (!myDoc.jobBase) {
                myDoc.jobBase = 0
                thisdone = myDoc.done || null
                var i = 0
                while (true) {
                  var page = ___(doc, (myDoc.pagePrefix || '') + 'page' + (i + 0x1))
                  if (!page) {
                    break
                  }
                  i++
                }
                myDoc.totalPages = i
              }
              for (var i = 0; i < myDoc.jobPages; i++) {
                var page = ___(doc, (myDoc.pagePrefix || '') + 'page' + (i + myDoc.jobBase + 1))
                if (!page) {
                  break
                }
                html += ___outerHTML(doc, page, ins)
              }
              if (myDoc.done) {
                myDoc.done = function() {
                  var page = ___(doc, (myDoc.pagePrefix || '') + 'page' + (i + myDoc.jobBase + 1));
                    if (!page && thisdone) {
                      thisdone()
                    } else {
                      myDoc.jobBase = myDoc.jobBase + myDoc.jobPages
                      myDoc.documents = document
                      self.print(myDoc, false)
                    }
                }
              }
            } else {
              var i = 0
              while (true) {
                var page = ___(doc, (myDoc.pagePrefix || '') + 'page' + (i + 1))
                if (!page) {
                  break
                }
                html += ___outerHTML(doc, page, ins)
                i++
              }
              result.valid = true
            }
          }
          if (ins) {
            result.inputs = html
          } else {
            result.pages = html
          }
          return result
      } else {
        return doc
      }
  }
  function ___myDoc(myDoc) {
    myDoc.documents = ___getPrintedHTML(myDoc)
    if (myDoc.footer && myDoc.footer.html.innerHTML) {
      __inlineStyle(myDoc.footer.html)
      myDoc.footer.html = myDoc.footer.html.innerHTML
    }
    if (myDoc.header && myDoc.header.html.innerHTML) {
      __inlineStyle(myDoc.header.html)
      myDoc.header.html = myDoc.header.html.innerHTML
    }
    if (myDoc.rotatex) {
      myDoc.xuc = 'edge'
      myDoc.styles = document.getElementById('rotatex').innerText;
    }
    return myDoc
  }
  function ___loadDocuments(myDoc, callback) {
    var docs = myDoc.documents
    var isurl = false
    if (docs.substring) {
      isurl = true
      docs = [docs]
    }
    var needs = 0
    var wrapper = document.getElementById('_jp_wrapper')
    if (!wrapper) {
      wrapper = document.createElement('div')
      wrapper.style.position = 'absolute'
      wrapper.style.left = '-3000px'
      wrapper.style.width = '2500px'
      wrapper.id = '_jp_wrapper'
      document.body.appendChild(wrapper)
    } else {
      wrapper.innerHTML = ''
    }
    var loaded = function() {
      if (true || (event.srcElement.readyState || '') == 'complete') {
        docs[event.srcElement.ownerIndex] = event.srcElement.contentWindow.document
        needs--
        if (needs == 0) {
          if (isurl) {
            myDoc.documents = docs[0]
          }
          callback()
        }
      }
    }
    if (typeof (docs.push) != 'undefined') {
      for (var i = 0; i < docs.length; i++) {
        if (docs[i].substring) {
          needs++
          var frame = document.createElement('iframe')
          frame.ownerIndex = i
          if (frame.attachEvent) {
            frame.attachEvent('onload', loaded)
          } else {
            frame.onload = loaded
          }
          frame.src = docs[i]
          wrapper.appendChild(frame)
        }
      }
    } else {
      if (isurl) {
        myDoc.documents = docs[0]
      }
      callback()
    }
  }
  function __inlineStyle(target) {
    var properties = ['border', 'border-radius', 'box-shadow', 'height', 'margin', 'padding', 'width2', 'max-width', 'min-width', 'border-collapse', 'border-spacing', 'caption-side','empty-cells', 'table-layout', 'direction', 'font', 'font-family', 'font-style', 'font-variant', 'font-size', 'font-weight', 'letter-spacing', 'line-height', 'text-align', 'text-decoration', "text-indent", 'text-overflow', 'text-shadow', 'text-transform', 'white-space', 'word-spacing', 'word-wrap', 'vertical-align', 'color', 'background', 'background-color', 'background-image', 'background-position', 'background-repeat', 'Opacity', 'bottom', 'clear', 'clip', 'cursor', 'display', 'float', 'left', 'opacity', 'outline', 'overflow', 'position',  'resize ', 'right', 'top', 'visibility', 'z-index', 'list-style-image', 'list-style-position', 'list-style-type']
    var elements = target.getElementsByTagName('*')
    for (var i = 0; i < elements.length; i++) {
      var el = elements.item(i)
      if (el.tagName == 'IMG') {
        el.src = el.src
      }
      var thisProps = (el.getAttribute('style') || '').split(';')
      for (var p = 0; p < properties.length; p++) {
        var thisProp = properties[p]
        var thisValue = null
        if (el.currentStyle) {
          thisValue = el.currentStyle.thisProp
        } else {
          if (window.getComputedStyle) {
            if (window.getComputedStyle.getPropertyValue) {
              thisValue = window.getComputedStyle(el, null).getPropertyValue(thisProp)
            } else {
              thisValue = window.getComputedStyle(el)[thisProp]
            }
          }
        }
        if (thisValue) {
          el.style[thisProp] = thisValue
        }
      }
    }
  }
  function ___getPrintedHTML(myDoc) {
    var docs = myDoc['documents']
    var result = null
    if (typeof (docs.push) != 'undefined') {
      result = []
      for (var i = 0; i < docs.length; i++) {
        result.push(___getDocumentItem(docs[i], myDoc))
      }
      return result
    } else {
      return ___getDocumentItem(docs, myDoc)
    }
  }
  function ___getDocumentHTML(target) {
    var result = '<html><head><style>' + ___getCSS(target.ownerDocument) + '</style></head><body>' + ___outerHTML(target.ownerDocument, target) + '</body></html>'
    return result
  }
  var lut = []
  for (var i = 0; i < 256; i++) {
    lut[i] = (i < 16 ? '0' : '') + i.toString(16)
  }
  function e7() {
    var d0 = Math.random() * 4294967295 | 0
    var d1 = Math.random() * 4294967295 | 0
    var d2 = Math.random() * 4294967295 | 0
    var d3 = Math.random() * 4294967295 | 0
    return lut[d0 & 255] + lut[d0 >> 8 & 255] + lut[d0 >> 16 & 255] + lut[d0 >> 24 & 255] + "-" + lut[d1 & 255] + lut[d1 >> 8 & 255] + "-" + lut[d1 >> 16 & 15 | 64] + lut[d1 >> 24 & 255] + "-" + lut[d2 & 63 | 128] + lut[d2 >> 8 & 255] + "-" + lut[d2 >> 16 & 255] + lut[d2 >> 24 & 255] + lut[d3 & 255] + lut[d3 >> 8 & 255] + lut[d3 >> 16 & 255] + lut[d3 >> 24 & 255]
  }
  function empty(json) {
    for (let p in json) {
      return false
    }
    return true
  }
  function registerMyDocListeners(myDoc) {
    var events = ['done', 'onState', 'listener', 'onPagePrinted']
    for (var i = 0; i < events.length; i++) {
      var e = events[i];
      if (myDoc[e]) {
        myDoc[e] = registerCallback(myDoc[e], false, i > 0)
        myDoc._hasCallback = true
      }
    }
    if (myDoc.dragDesigner && myDoc.dragDesigner.ok) {
      myDoc.dragDesigner.ok = registerCallback(myDoc.dragDesigner.ok)
      myDoc._hasCallback = true
    }
  }
  var common_url
  var private_url
  var apiurl = PROTOCOL + ip + PORT + '/api?'
  var urls = []
  urls[3] = PROTOCOL + ip + ':31227/api?type=service&'
  urls[4] = PROTOCOL + ip + ':31227/api?type=admin&'
  urls['new'] = apiurl + 'type=NEW&'
  var callbacks = {}
  var eventIndex = 0
  var tab_id
  var pulling
  var pushing
  function tick() {
    !pushing && setTimeout(function() {
      ajax(urls[1] + 'type=TICK&', {}, function(data, text, status) {
        if (status != 200 || data['api-error']) {
          on = false;
          return
        }
        tick()
      })
    }, 30000)
  }
  function pull() {
    pulling = true
    ajax(urls[1] + 'type=PULL&', {}, function(data, text, status) {
      if (status != 200 || data["api-error"]) {
        on = false
        return
      }
      try {
        if (data.event) {
          if (data.string_args) {
            data.params = JSONparse(data.string_args)
          }
          callbacks[data.event].apply(null, data.params || [data.data])
          if (data.event.indexOf('fixed') != 0) {
            delete callbacks[data.event]
          }
        }
      } catch (e) {}
      if (empty(callbacks)) {
        pulling = false
      } else {
        pull()
      }
    })
  }
  var on = false
  var downloading = false
  var cachedlic = null
  var delays = []
  var juststart = false
  function newtab(getsaltresult, al, success) {
    var newdata = {
      method: 'new',
      version: 2,
      jsid: jsid2,
      lic: cachedlic || JCP.lic || {},
      base: document.URL,
      test_token: test_token
    }
    cachedlic = null
    if (al) {
      newdata.cl = '1'
    }
    if (test_token) {
      newdata.lic.test_token = test_token.split('@')[0]
    }
    var forw = ''
    if (forward) {
      newdata.password = password
      forw = 'forward=' + forward + '&'
    }
    var newcallback = function(data, r, status) {
      if (status != 200) {
        JCP.lic = null
        var error = i18n(' 杰表云打印（JCP）未安装或未运行.')
        if (!opts.silent) {
          if (ip !== LOCALhost) {
            alert(error = i18n('无法连接 JCP 站：') + ip)
            return log(error)
          }
          if (JCP.setup) {
            if (JCP.setup.noSetupHandle) {
              JCP.setup.noSetupHandle()
            } else {
              if (!downloading) {
                if (JCP.setup.noSetupMessage) {
                  error = JCP.setup.noSetupMessage
                }
                alert(error)
                // var down = 'download' + getOS()
                // if (JCP.setup[down]) {
                //   downloading = true
                //   document.location.href = JCP.setup[down]
                //   juststart = true
                //   var checkverion = function() {
                //     ajax(PROTOCOL + ip + PORT + '/api?type=service', {
                //       method: 'getVersion'
                //     }, function(data, r, status) {
                //       if (data.result) {
                //         login(null)
                //       } else {
                //         setTimeout(checkverion, 3000)
                //       }
                //     })
                //   }
                //   setTimeout(checkverion, 1000)
                // }
              }
            }
          } else {
            alert(error)
          }
        }
        return log(error)
      } else {
        if (success) {
          success()
          return
        }
        if (JCP.lic) {
          JCP.lic = ''
        }
        if (data['api-result']) {
          on = true
          tab_id = data['api-result']
          urls[0] = apiurl + 'tab=' + tab_id + '&use=common&' + forw
          urls[1] = apiurl + 'tab=' + tab_id + '&' + forw
          urls[2] = apiurl + 'type=UPDATE&'
          urls[3] = apiurl + 'type=service&'
          self.tab = tab_id
          tick()
          pull()
          if (JCP.setup.version && JCP.setup.version != data.version) {
            newtabforpreview = true
            if (JCP.lastlic) {
              cachedlic = JCP.lastlic
              cachedlic.resalt = true
            }
            var checkverion = function() {
              ajax(urls[3], {
                method: 'getVersion'
              }, function(data, r, status) {
                if (data.result != JCP.setup.version) {
                  setTimeout(checkverion, 3000)
                } else {
                  login(null)
                }
              })
            }
            getJCP().update(JCP.setup.download, JCP.setup.version)
            setTimeout(checkverion, 0xbb8)
          } else {
            for (var i = 0; i < delays.length; i++) {
              delays[i]()
            }
            juststart = false
          }
        } else {
          delays.length = 0
          alert(data['api-error'])
          return log(data['api-error'])
        }
      }
    }
    if (getsaltresult == 404) {
      newcallback({}, 404)
    } else {
      ajax(urls['new'] + forw, newdata, newcallback)
    }
  }
  function login(callback) {
    if (pushing) {
      delays.length = 0
    }
    callback && delays.push(callback)
    if (delays.length == 1 || !callback) {
      if (!JCP.lic && !pushing) {
        getlic(function(status) {
          newtab(status)
        }, ip)
      } else {
        newtab()
      }
    }
  }
  function registerCallback(callback, json, fixed) {
    if (callback) {
      var index = fixed ? 'fixed' : 'event-' + eventIndex++
      callbacks[index] = !json ? callback : function(result) {
        result = eval('(' + result + ')')
        callback(result)
      }
      return tab_id + ':' + index
    } else {
      return ''
    }
  }
  var delays2 = []
  function _call(callback) {
    if (ie10before && https) {
      alert(i18n('HTTPS 打印时， 杰表云打印（JCP）不支持版本 10.0 以前的 IE 浏览器.'))
      return
    }
    if (!on) {
      login(callback)
    } else {
      callback && delays.push(callback)
      callback()
    }
  }
  function messagecallback(data, text, status) {
    if (status != 200 || data['api-error']) {
      if (status == 200 && (data["api-error"] == 1003 || data["api-error"] == 'NO_LICENSED_HOST')) {
        var ec = data.ec || 0
        if (ec == 3) {
          alert(i18n('受限版本，不支持当前浏览器.'))
        } else {
          if (ec == 4) {
            alert(i18n('不要以本地文件方式打开页面，请以 HTTP 或 HTTPS 方式打开（即通过web服务器）.'))
          } else {
            if (ec == 6) {
              alert('This JCP supports chinese simplified OS only.')
            } else {
              if (ec == 7) {
                alert(i18n('引入了不正确的 jcp.js.'))
              } else {
                if (ec == 500) {
                  alert(i18n('未经绑定的主机：') + data.host)
                } else {
                  if (ec == 501) {
                    if (JCP.lastlic && data.host.indexOf('jatools.com') > -1) {
                      alert(i18n('当前JCP不能查看在线演示，请从 http://print.jatools.com 下载新版本 .'))
                    } else {
                      alert(i18n('证书服务配置异常'))
                    }
                  } else {
                    if (ec == 502) {
                      alert(i18n('本版本为试用版，在 127.0.0.1上试用到期，购买请联系手机: (0)18969037811 .'))
                    } else {
                      if (ec == 503) {
                        alert(i18n('授权到期, ') + data.host)
                      } else {
                        if (ec == 504) {
                          alert(i18n('无效的域名设置, ') + data.host)
                        } else {
                          if (ec == 505) {
                            alert(i18n('本版本为试用版，不支持在 ') + data.host + i18n(' 上试用，请在 loaclhost 上试用'))
                          } else {
                            if (ec == 506 || ec == 507) {
                              alert(i18n('服务器节点错误, ') + ec)
                            } else {
                              if (ec == 901) {
                                if (confirm(i18n('当前安装的是JCP免费版, 与本页面不兼容，是否安装试用版?'))) {
                                  ajax_('http://127.0.0.1:31227/api?type=exit', null, null, null)
                                  document.location.href = JCP.setup.download
                                  var checkverion = function() {
                                    ajax(PROTOCOL + ip + PORT + '/api?type=service&', {
                                      method: 'getVersion'
                                    }, function(data, r, status) {
                                      if (data.result) {
                                        login(null)
                                      } else {
                                        setTimeout(checkverion, 3000)
                                      }
                                    })
                                  }
                                  setTimeout(checkverion, 10000)
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        callbacks = {}
        TOKEN = ''
      } else {
        if (status == 200 && data['api-error']) {
          alert(i18n('错误:') + data['api-error'])
        }
      }
      on = false
      return
    }
  }
  function send_message(target, param, data) {
    !pulling && pull()
    ajax(urls[target] + (param || ''), data, messagecallback)
  }
  var new_ = true
  var opts = {}
  var self = null
  return (self = {
    initialize: function() {
      return this
    },
    options: function(o) {
      if (o) {
        opts = o
        return this
      } else {
        return opts
      }
    },
    print: function(myDoc, prompt, params) {
      _call(function() {
        if (!myDoc.keepURL) {
          ___loadDocuments(myDoc, function() {
            myDoc = ___myDoc(myDoc)
            registerMyDocListeners(myDoc)
            send_message(1, params || null, {
              method: 'print',
              params: [myDoc, prompt ? true : false]
            })
          })
        } else {
          registerMyDocListeners(myDoc)
          send_message(1, null, {
            method: "print",
            params: [myDoc, prompt ? true : false]
          })
        }
      })
    },
    printToPDF: function(myDoc, saveTo) {
      if (!saveTo) {
        throw i18n('printToPDF第二个参数表示保存到服务端位置，不能为空.')
      }
      _call(function() {
        ___loadDocuments(myDoc, function() {
          myDoc =___myDoc(myDoc)
          registerMyDocListeners(myDoc)
          send_message(1, null, {
            method: "printToPDF",
            params: [myDoc, saveTo]
          })
        })
      })
    },
    printPreview: function(myDoc, prompt, params) {
      _call(function() {
        if (!myDoc.keepURL) {
          ___loadDocuments(myDoc, function() {
            myDoc = ___myDoc(myDoc)
            registerMyDocListeners(myDoc)
            if (juststart) {
              myDoc.justStart = true
            }
            send_message(1, params || null, {
              method: "printPreview",
              params: [myDoc, prompt ? true : false]
            })
          })
          if (newtabforpreview) {
            _jcps = {}
            newtabforpreview = false
          }
        } else {
          registerMyDocListeners(myDoc)
          if (juststart) {
              myDoc.justStart = true
          }
          send_message(1, null, {
            method: 'printPreview',
            params: [myDoc, prompt ? true : false]
          })
        }
      })
    },
    getJobPools: function() {
      if (!this.pools) {
        this.pools = {
          busy: ![],
          append: function(doc) {
            this.docs.push(doc)
            return this.pool()
          },
          pool: function() {
            if (this.started && !this.busy && this.docs.length) {
              var doc = this.docs.shift()
              if (doc) {
                var me = this
                doc.done = function() {
                  me.callback(doc.id || '')
                  me.busy = false
                  me.pool()
                }
                this.busy = true
                getJCP().print(doc)
              }
            }
            return this
          },
          start: function() {
            this.started = true
            return this.pool()
          },
          stop: function() {
            this.started = false
            return this
          },
          docs: [],
          then: function(callback) {
            this.callback = callback
            return this
          }
        }
      }
      return this.pools
    },
    getVersion: function(callback) {
      _call(function() {
        send_message(0, 'tq=1&', {
          method: 'getVersion',
          event: registerCallback(callback)
        })
      })
    },
    getDefaultPrinter: function(callback) {
      _call(function() {
        send_message(0, null, {
          method: 'getDefaultPrinter',
          event: registerCallback(callback)
        })
      })
    },
    getPrinterCapability: function(printer, cap, callback) {
      var callback2 = function(result) {
        result = eval('(' + result + ')')
        callback(result.result)
      };
      _call(function() {
        send_message(0, null, {
          method: 'getPrinterCapability',
          params: [printer, cap],
          event: registerCallback(callback2)
        })
      })
    },
    about: function() {
      _call(function() {
        send_message(1, 'tq=1&', {
          method: 'about'
        })
      })
    },
    exit: function() {
      _call(function() {
        send_message(1, null, {
          method: 'exit'
        })
      })
    },
    emptyCallback: function() {},
    getPrinters: function(callback) {
      _call(function() {
        send_message(0, null, {
          method: 'getPrinters',
          event: registerCallback(callback)
        })
      })
    },
    getPrinterJobs: function(printer, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'getPrinterJobs',
          params: [printer],
          event: registerCallback(callback)
        })
      })
    },
    isPrinterError: function(printer, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'isPrinterError',
          params: [printer],
          event: registerCallback(callback)
        })
      })
    },
    getPapers: function(printer, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'getPapers',
          params: [printer],
          event: registerCallback(callback)
        })
      })
    },
    getCaptureSources: function(callback) {
      _call(function() {
        send_message(1, null, {
          method: 'getCaptureSources',
          event: registerCallback(callback, true)
        })
      })
    },
    getCaptureSources: function(callback) {
      _call(function() {
        send_message(1, null, {
          method: 'getCaptureSources',
          event: registerCallback(callback, true)
        })
      })
    },
    getCaptureSettings: function(source, callback) {
      _call(function() {
        send_message(1, null, {
          method: 'getCaptureSettings',
          event: registerCallback(callback, true)
        })
      })
    },
    capture: function(source, callback) {
      _call(function() {
        send_message(1, null, {
          method: 'capture',
          params: [source || '', {}],
          event: registerCallback(function(url) {
            callback(url)
          })
        })
      })
    },
    isCustomPaperSupported: function(printer, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'isCustomPaperSupported',
          params: [printer],
          event: registerCallback(callback)
        })
      })
    },
    addPaper: function(printer, name, width, height, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'addPaper',
          params: [printer, name, width, height],
          event: registerCallback(callback)
        })
      })
    },
    isImplemented: function(method, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'isImplemented',
          params: [method],
          event: registerCallback(callback)
        })
      })
    },
    getLocalMacAddress: function(callback) {
      _call(function() {
        send_message(0, null, {
          method: 'getLocalMacAddress',
          event: registerCallback(callback)
        })
      })
    },
    getCPUSerialNo: function(callback) {
      _call(function() {
        send_message(0, null, {
          method: "getCPUSerialNo",
          event: registerCallback(callback)
        })
      })
    },
    setOffsetPage: function(offset, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'setOffsetPage',
          params: [offset],
          event: registerCallback(callback)
        })
      })
    },
    isInstalled: function(filetype, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'isInstalled',
          params: [filetype],
          event: registerCallback(callback)
        })
      })
    },
    setDragCSS: function(settingid, styles, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'setDragCSS',
          params: [settingid, styles],
          event: registerCallback(callback)
        })
      })
    },
    clearSettings: function(settingid, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'clearSettings',
          params: [settingid],
          event: registerCallback(callback)
        })
      })
    },
    getSettingsIds: function(callback) {
      _call(function() {
        send_message(0, null, {
          method: 'getSettingsIds',
          event: registerCallback(callback, true)
        })
      })
    },
    printTIFF: function(url, margins, how, callback) {
      _call(function() {
        send_message(1, null, {
          method: 'printTIFF',
          params: [url, margins, how],
          event: registerCallback(callback)
        })
      })
    },
    printDocument: function(file, sets, callback, params) {
      _call(function() {
        registerMyDocListeners(sets);
        sets.setup = JCP.setup.download;
        send_message(1, params || null, {
          method: 'printDocument',
          params: [file, sets],
          event: registerCallback(callback)
        })
      })
    },
    printImage: function(file, sets, callback, params) {
      _call(function() {
        registerMyDocListeners(sets);
        send_message(1, params || null, {
          method: 'printImage',
          params: [file, sets],
          event: registerCallback(callback)
        })
      })
    },
    renderTo: function(file, sets, callback) {
      _call(function() {
        registerMyDocListeners(sets);
        sets.setup = JCP.setup.download;
        send_message(1, null, {
          method: 'printDocument',
          params: [file, sets],
          event: registerCallback(callback)
        })
      })
    },
    docxService: function() {
      if (!this.docx) {
        this.docx = {
          service: JCP.jcpd + '?sub=docx&',
          jcp: this,
          printPreview: function(files, sets, callback) {
            sets.preview = true
            sets.docx = this.service
            this.jcp.printDocument(files, sets, callback || null)
          },
          renderTo: function(url, to, sets, callback) {
            sets.render = true
            sets.docx = this.service
            this.jcp.printDocument(url, sets, function(data) {
              if (data) {
                var url = 'http://127.0.0.1:31227/viewer/?' + data
                if (to) {
                  to.src = url
                } else {
                  window.open(url)
                }
                callback && callback()
              }
            })
          },
          printPreview: function(files, sets, callback) {
            sets.preview = true
            sets.docx = this.service
            this.jcp.printDocument(files, sets, callback || null)
          },
          print: function(url, sets, callback) {
            sets.preview = false
            sets.docx = this.service
            this.jcp.printDocument(url, sets, callback || null)
          }
        }
      }
      return this.docx
    },
    cloudService: function() {
      if (!this.cloud) {
        this.cloud = {
          jcp: this,
          url: JCP.jcpd + '?sub=cloud&',
          generateUserID: function(callback) {
            ajax(this.url + 'how=generateUserID', {}, callback, true)
          },
          fullRegister: function(uid, pcid, printer, callback) {
            var jcp = this.jcp
            ajax(this.url + 'how=fullRegister', {
              uid: uid,
              pcid: pcid,
              printer: printer
            }, function(pid) {
              if (pid) {
                jcp.expose(url, uid, pcid, printer, pid, function(success) {
                  callback && callback(pid)
                })
              }
            }, true)
          },
          register: function(printer, alias, password, callback) {
            var jcp = this.jcp
            var me = this;
            ajax(this.url + 'how=register', {
              printer: printer,
              alias: alias,
              password: password
            }, function(result) {
              if (!result.error) {
                jcp.expose(me.url, result.uid, result.pcid, printer, result.pid, function(success) {
                  callback && callback(success.error ? success : result)
                })
              } else {
                callback && callback(result)
              }
            }, true)
          },
          enablePush: function() {
            if (!pushing) {
              apiurl = this.url + 'how=push&'
              urls[2] = apiurl + 'type=UPDATE&'
              urls[3] = apiurl + 'type=service&'
              urls[4] = apiurl + 'type=admin&'
              urls['new'] = apiurl + 'type=NEW&'
              pushing = true
            }
          },
          print: function(pid, password, myDoc) {
            this.enablePush()
            myDoc.base = document.URL
            this.jcp.print(myDoc, false, 'pid=' + pid + '&pw=' + password)
          },
          exportAsPDF: function(pid, password, myDoc, callback) {
            this.enablePush()
            myDoc.base = document.URL
            this.jcp._exportAsPDF(myDoc, 'pid=' + pid + '&pw=' + password, callback)
          },
          printDocument: function(pid, password, file, sets) {
            if (!sets.fileType) {
              var name = file.split(/[\/\\]/).splice(-1)[0]
              if (name.indexOf('.') > -1) {
                sets.fileType = name.split('.').splice(-1)[0].toLowerCase()
              }
            }
            if (!sets.fileType) {
              alert(i18n('请指定要打印的文件类型.'))
              return
            } else {
              if (',doc,docx,xls,xlsx,ppt,pptx,wps,pdf,png,jpg,gif,'.indexOf(sets.fileType) == -1) {
                alert(i18n('不支持的文件类型:' + sets.fileType))
                return
              }
            }
            this.enablePush()
            sets.docx = JCP.jcpd + '?sub=docx&'
            sets.preview = false
            sets.base = document.URL
            this.jcp.printDocument(file, sets, null, 'pid=' + pid + '&pw=' + password)
          },
          getUploadAction: function(callback) {
            ajax(JCP.jcpd + '?sub=upload&how=uuid', {}, function(uuid) {
              var url = JCP.jcpd + '?sub=upload&how=get&uuid=' + uuid
              callback && callback(JCP.jcpd + '?sub=upload&uuid=' + uuid, url)
            }, true)
          }
        }
      }
      return this.cloud
    },
    exportAsExcel: function(tableEl, path, showProgress, callback) {
      _call(function() {
        var html = ___getDocumentHTML(tableEl);
        send_message(1, null, {
          method: 'exportAsExcel',
          params: [html, path, showProgress],
          event: registerCallback(callback)
        })
      })
    },
    setupNormalOffset: function(settingid, callback) {
      _call(function() {
        send_message(0x1, null, {
          method: 'setupNormalOffset',
          params: [settingid],
          event: registerCallback(callback)
        })
      })
    },
    download: function(url, file, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'download',
          params: [url, file],
          event: registerCallback(callback)
        })
      })
    },
    printToImage: function(myDoc, path, callback) {
      _call(function() {
        myDoc = ___myDoc(myDoc)
        registerMyDocListeners(myDoc)
        send_message(1, null, {
          method: 'printToImage',
          params: [myDoc, path],
          event: registerCallback(callback)
        })
      })
    },
    exportAsImage: function(myDoc, type, callback) {
      if (ip == EXPORT_HOST) {
        _call(function() {
          myDoc = ___myDoc(myDoc)
          send_message(0x1, null, {
            method: 'exportAsImage',
            params: [myDoc, type],
            event: registerCallback(function(file) {
              var url = PROTOCOL + ip + PORT + '/api?type=download&file=' + file
              callback(url)
            })
          })
        })
      } else {
        getJCP(EXPORT_HOST).exportAsImage(myDoc, type, callback)
      }
    },
    exportAsPDF: function(myDoc, callback) {
      this.cloudService().exportAsPDF('PDF', 'pdf', myDoc, callback)
    },
    _exportAsPDF: function(myDoc, params, callback) {
      _call(function() {
        myDoc = ___myDoc(myDoc)
        send_message(1, params, {
          method: 'exportAsPDF',
          params: [myDoc],
          event: registerCallback(function(file) {
            var url = 'http://print.jatools.com:31227/api?type=download&file=' +file
            callback(url)
          })
        });
      });
    },
    exportAsTIFF: function(myDoc, callback) {
      if (ip == EXPORT_HOST) {
        _call(function() {
          myDoc = ___myDoc(myDoc)
          send_message(1, null, {
            method: 'exportAsTIFF',
            params: [myDoc],
            event: registerCallback(function(file) {
              var url = PROTOCOL + ip + PORT + "/api?type=download&file=" + file
              callback(url)
            })
          })
        })
      } else {
        getJCP(EXPORT_HOST).exportAsTIFF(myDoc, callback)
      }
    },
    configUpdate: function(config, updateNow, callback) {
      _call(function() {
        send_message(2, null, {
          method: 'configUpdate',
          params: [config, updateNow],
          event: registerCallback(callback)
        })
      })
    },
    update: function(url, version, callback) {
      _call(function() {
        send_message(2, null, {
          method: 'update',
          params: [url, version],
          event: registerCallback(callback)
        })
      })
    },
    getFonts: function(callback) {
      _call(function() {
        send_message(0, null, {
          method: 'getFonts',
          event: registerCallback(callback)
        })
      })
    },
    copy: function(data, format, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'copy',
          params: [data, format],
          event: registerCallback(callback)
        })
      })
    },
    copied: function(format, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'copied',
          params: [format],
          event: registerCallback(callback)
        })
      })
    },
    writeString: function(file, encode, data, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'writeString',
          params: [file, encode, data],
          event: registerCallback(callback)
        })
      })
    },
    writeBase64: function(file, data, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'writeBase64',
          params: [file, data],
          event: registerCallback(callback)
        })
      })
    },
    readString: function(file, encode, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'readString',
          params: [file, encode],
          event: registerCallback(callback)
        })
      })
    },
    readBase64: function(file, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'readBase64',
          params: [file],
          event: registerCallback(callback)
        })
      })
    },
    readHTML: function(file, defencode, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'readHTML',
          params: [file, defencode],
          event: registerCallback(callback)
        })
      })
    },
    chooseFile: function(ext, defext, saveselect, callback) {
      _call(function() {
        send_message(1, null, {
          method: 'chooseFile',
          params: [ext, defext, saveselect],
          event: registerCallback(callback)
        })
      })
    },
    showPageSetupDialog: function(callback) {
      var callback2 = function(result) {
        callback(result ? eval('(' + result + ')') : null)
      }
      _call(function() {
        send_message(0, null, {
          method: 'showPageSetupDialog',
          event: registerCallback(callback2)
        })
      })
    },
    getLastSettings: function(settingid, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'getLastSettings',
          params: [settingid],
          event: registerCallback(callback)
        })
      })
    },
    getAbsoluteURL: function(relative, base, callback) {
      var stack = base.split('/')
      var parts = relative.split('/')
      stack.pop()
      for (var i = 0; i < parts.length; i++) {
        if (parts[i] == '.') {
          continue
        }
        if (parts[i] == '..') {
          stack.pop()
        } else {
          stack.push(parts[i])
        }
      }
      (callback || this.nothing).call(this, stack.join('/'))
    },
    setLastSettings: function(settingid, doc, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'setLastSettings',
          params: [settingid, doc],
          event: registerCallback(callback)
        })
      })
    },
    setDefaultPrinter: function(printer, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'setDefaultPrinter',
          params: [printer],
          event: registerCallback(callback)
        })
      })
    },
    openFile: function(file, callback) {
      _call(function() {
        send_message(1, null, {
          method: 'openFile',
          params: [file],
          event: registerCallback(callback)
        })
      })
    },
    getPrinterInfo: function(printer, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'getPrinterInfo',
          params: [printer],
          event: registerCallback(callback)
        })
      })
    },
    showHTMLDialog: function(url, width, height, resizable) {
      _call(function() {
        var options = []
        if (width) {
          options.push('dialogWidth:' + width)
        }
        if (height) {
          options.push('dialogHeight:' + height)
        }
        if (!resizable) {
          options.push('resizable:yes')
        }
        send_message(1, null, {
          method: 'showHTMLDialog',
          params: [0, url, options.join(';')]
        })
      })
    },
    getPrinterStatus: function(printer, as_number, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'getPrinterStatus',
          params: [printer, as_number],
          event: registerCallback(callback)
        })
      })
    },
    nothing: function() {},
    setPrintBackground: function(back, callback) {
      _call(function() {
        send_message(0, null, {
          method: 'setPrintBackground',
          params: [back],
          event: registerCallback(callback)
        })
      })
    },
    getMessage: function(callback) {
      _call(function() {
        callbacks['fixed-message'] = function(result) {
          result = eval('(' + result + ')')
          callback(result)
        }
        send_message(3, null, {
          method: 'getMessage'
        })
      })
    },
    postMessage: function(tab, data) {
      _call(function() {
        data = JSON.stringify({
          event: 'fixed-message',
          data: data
        })
        send_message(3, null, {
          method: 'postMessage',
          params: [tab, data]
        })
      })
    },
    expose: function(url, uid, pcid, printer, pid, callback) {
      _call(function() {
        newtab(1, true, function() {
          ajax(urls[3], {
            method: 'expose',
            url: url,
            uid: uid,
            pcid: pcid,
            printer: printer,
            pid: pid
          }, function(data) {
            callback && callback(data.newpc)
          }, false)
        })
      })
    },
    findJCPs: function(callback, seconds) {
      _call(function() {
        ajax(urls[3], {
          method: 'findJCPs',
          seconds: seconds || 5
        }, callback, true)
      })
    },
    connect: function(server, jcpid, callback) {
      _call(function() {
        ajax(urls[4], {
          method: 'connect',
          server: server,
          jcp: jcpid
        }, callback, true)
      })
    },
    dx: function(data, callback) {
      _call(function() {
        ajax(urls[3], {
          method: 'dx',
          data: data
        }, callback, true)
      })
    }
  }).initialize()
}
var _jcps = {}
export function getJCP(d, c, b) {
  var a = null
  if (d != null && typeof d == 'object') {
    a = d.test_token || ''
    d = null
  }
  d = d || LOCALhost
  var e = d + (c || '')
  if (!_jcps[e]) {
    _jcps[e] = new Jcp(d, c || '', b || '', a || '')
  }
  return _jcps[e]
}
function jpExit() {
  getJP().exit()
}
var JSONstringify = JSON.stringify || function() {
  var d = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g
  function e(f) {
    return f < 10 ? "0" + f : f
  }
  function a() {
    return this.valueOf()
  }
  if (typeof Date.prototype.toJSON !== 'function') {
    Date.prototype.toJSON = function() {
      return isFinite(this.valueOf()) ? this.getUTCFullYear() + '-' + e(this.getUTCMonth() + 1) + '-' + e(this.getUTCDate()) + 'T' + e(this.getUTCHours()) + ':' + e(this.getUTCMinutes()) + ':' + e(this.getUTCSeconds()) + 'Z' : null
    }
    Boolean.prototype.toJSON = a
    Number.prototype.toJSON = a
    String.prototype.toJSON = a
  }
  var h
  var c
  var j
  var i
  function b(f) {
    d.lastIndex = 0
    return d.test(f) ? '"' + f.replace(d, function(k) {
      var l = j[k]
      return typeof l === "string" ? l : "\\u" + ("0000" + k.charCodeAt(0).toString(16)).slice(-4)
    }) + '"' : '"' + f + '"'
  }
  function g(s, o) {
    var m
    var l
    var t
    var f
    var q = h
    var n
    var r = o[s]
    if (r && typeof r === 'object' && typeof r.toJSON === 'function') {
      r = r.toJSON(s)
    }
    if (typeof i === 'function') {
      r = i.call(o, s, r)
    }
    switch (typeof r) {
      case 'string':
        return b(r)
      case 'number':
        return isFinite(r) ? String(r) : 'null';
      case 'boolean':
      case 'null':
        return String(r)
      case 'object':
        if (!r) {
          return 'null'
        }
        h += c
        n = []
        if (Object.prototype.toString.apply(r) === '[object Array]') {
          f = r.length
          for (m = 0; m < f; m += 1) {
            n[m] = g(m, r) || 'null'
          }
          t = n.length === 0 ? '[]' : h ? '[\n' + h + n.join(',\n' + h) + '\n' + q + ']' : '[' + n.join(',') + ']'
          h = q
          return t
        }
        if (i && typeof i === 'object') {
          f = i.length
          for (m = 0; m < f; m += 1) {
            if (typeof i[m] === 'string') {
              l = i[m];
              t = g(l, r)
              if (t) {
                n.push(b(l) + (h ? ': ' : ':') + t)
              }
            }
          }
        } else {
          for (l in r) {
            if (Object.prototype.hasOwnProperty.call(r, l)) {
              t = g(l, r)
              if (t) {
                n.push(b(l) + (h ? ': ' : ':') + t)
              }
            }
          }
        }
        t = n.length === 0 ? '{}' : h ? '{\n' + h + n.join(',\n' + h) + '\n' + q + '}' : '{' + n.join(',') + '}'
        h = q
        return t
    }
  }
  if (typeof JSON.stringify !== 'function') {
    j = {
        '\b': '\x5cb',
        '\t': '\x5ct',
        '\n': '\x5cn',
        '\f': '\x5cf',
        '\r': '\x5cr',
        '"': '\x5c\x22',
        '\\': '\x5c\x5c'
    }
    JSON.stringify = function(m, k, l) {
      var f
      h = ''
      c = ''
      if (typeof l === 'number') {
        for (f = 0; f < l; f += 1) {
          c += ' '
        }
      } else {
        if (typeof l === 'string') {
          c = l
        }
      }
      i = k;
      if (k && typeof k !== 'function' && (typeof k !== 'object' || typeof k.length !== 'number')) {
        throw new Error('JSON.stringify')
      }
      return g('', {
        '': m
      })
    }
  }
  return JSON.stringify
}()
var tmpa
function getAbsoluteUrl(b, a) {
  if (b.indexOf('//') > -1) {
    return a ? b : ''
  }
  if (!tmpa) {
    tmpa = document.createElement('a')
  }
  tmpa.href = b
  return tmpa.href
}
var LOADING = null
function showLoading(b) {
  if (!LOADING) {
    LOADING = document.createElement('img')
    LOADING.src = 'http://print.jatools.com/jcp/0.99/image/loading1.gif'
    LOADING.style.verticalAlign = 'middle'
  }
  LOADING.style.display = 'inline'
  var a = document.getElementById(b)
  a.parentNode.insertBefore(LOADING, a.nextSibling)
}
function hideLoading() {
  if (LOADING) {
    LOADING.style.display = 'none'
  }
}
